"use strict";
var AdvancedForm = /** @class */ (function () {
    function AdvancedForm(formElement) {
        this.formElement = formElement;
        this.basicUploader();
        this.setupFieldRules();
    }
    AdvancedForm.prototype.getBytes = function (megabytes) {
        if (typeof megabytes !== 'number') {
            return;
        }
        return megabytes * (Math.pow((Math.pow(2, 10)), 2));
    };
    AdvancedForm.prototype.formatBytes = function (bytes) {
        if (typeof bytes === 'undefined' || /\D/.test(bytes.toString())) {
            return "N/A";
        }
        var suffixes = ['B', 'KB', 'MB', 'GB', 'TB'];
        var multiplier = 0;
        do {
            multiplier++;
        } while (bytes > Math.pow(1024, multiplier) && multiplier < suffixes.length);
        multiplier--;
        return bytes / Math.pow(1024, multiplier) + ' ' + suffixes[multiplier];
    };
    AdvancedForm.prototype.defaultValue = function (value, fallback) {
        return typeof value === 'undefined' ? fallback : value;
    };
    AdvancedForm.prototype.getMimeFromExt = function (ext) {
        var extMimes = {
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
        };
        if (typeof extMimes[ext] !== 'undefined') {
            return extMimes[ext];
        }
        return '';
    };
    AdvancedForm.prototype.getExtFromMime = function (mime) {
        var mimeExt = {
            'image/jpeg': 'jpg',
            'image/png': 'png',
            'image/gif': 'gif',
        };
        if (typeof mimeExt[mime] !== 'undefined') {
            return mimeExt[mime];
        }
        return '';
    };
    AdvancedForm.prototype.randomString = function () {
        return new Date().valueOf().toString(36) + Math.random().toString(36).substr(2);
    };
    AdvancedForm.prototype.acfFieldEvent = function (field, event, callback) {
        if (!field) {
            return;
        }
        var callbackName = event.substr(0, event.indexOf(' ')) + '_' + this.randomString();
        field[callbackName] = callback;
        field._add_event.call(field, event, callbackName);
    };
    AdvancedForm.prototype.acfFieldAction = function (field, action, callback) {
        if (!field) {
            return;
        }
        var callbackName = action + '_' + this.randomString();
        field[callbackName] = callback;
        field._add_action.call(field, action, callbackName);
    };
    AdvancedForm.prototype.basicUploader = function () {
        var _this = this;
        var $ = jQuery;
        var form = this;
        var inputSelector = 'input[type="file"]';
        this.acfFieldEvent(acf.fields.image, 'click a[data-name="remove"]', function () {
            // Reset the file input field
            this.$input.outerHTML = this.$input.outerHTML;
            this.$field.removeClass('has-value');
        });
        this.acfFieldEvent(acf.fields.image, 'change input[type="file"]', function () {
            var _this = this;
            var mimeTypes = this.o.mime_types.split(',').filter(String);
            var minWidth = form.defaultValue(this.$field.data('min_width'), 0);
            var minHeight = form.defaultValue(this.$field.data('min_height'), 0);
            var minSize = form.getBytes(form.defaultValue(this.$field.data('min_size'), 0));
            var maxWidth = form.defaultValue(this.$field.data('max_width'), Infinity);
            var maxHeight = form.defaultValue(this.$field.data('max_height'), Infinity);
            var maxSize = form.getBytes(form.defaultValue(this.$field.data('max_size'), Infinity));
            var files = this.$el.find('input:file').get(0).files;
            if (!files || files.length === 0) {
                return;
            }
            var file = files[0];
            var image = new Image();
            image.onload = function (e) {
                var validationOrder = [
                    'mimeTypes',
                    'minSize',
                    'maxSize',
                    'minWidth',
                    'maxWidth',
                    'minHeight',
                    'maxHeight',
                    'aspect',
                ];
                var validations = {
                    mimeTypes: !mimeTypes.length || mimeTypes.indexOf(form.getExtFromMime(file.type)) !== -1,
                    minSize: file.size >= minSize,
                    maxSize: file.size <= maxSize,
                    minWidth: image.width >= minWidth,
                    maxWidth: image.width <= maxWidth,
                    minHeight: image.height >= minHeight,
                    maxHeight: image.height <= maxHeight,
                    aspect: (image.height === image.width ||
                        Math.min(minHeight, maxHeight) === Math.min(minWidth, maxWidth) ||
                        (image.height < image.width && Math.min(minHeight, maxHeight) < Math.min(minWidth, maxWidth)) ||
                        (image.height > image.width && Math.min(minHeight, maxHeight) > Math.min(minWidth, maxWidth))),
                };
                var messages = {
                    mimeTypes: 'File type is not allowed',
                    minSize: "Image must be at least " + form.formatBytes(minSize),
                    maxSize: "Image cannot be larger than " + form.formatBytes(maxSize),
                    minWidth: "Image dimensions must be at least " + minWidth + "&times;" + minHeight,
                    maxWidth: "Image dimensions cannot be larger than " + maxWidth + "&times;" + maxHeight,
                    minHeight: "Image dimensions must be at least " + minWidth + "&times;" + minHeight,
                    maxHeight: "Image dimensions cannot be larger than " + maxWidth + "&times;" + maxHeight,
                    aspect: "Image must be a " + (image.height > image.width ? 'landscape' : 'portrait') + " aspect ratio",
                };
                var failed = validationOrder.filter(function (validation) { return !validations[validation]; });
                if (failed.length) {
                    acf.validation.add_error(_this.$field, messages[failed[0]]);
                    _this.$field.find('a[data-name="remove"]').triggerHandler('click');
                    return;
                }
                var image_url = URL.createObjectURL(file);
                _this.$field.find('img').attr('src', image_url);
                _this.$field.addClass('has-value');
            };
            image.onerror = image.onload;
            image.src = URL.createObjectURL(file);
        });
        $('.acf-image-uploader[data-uploader="basic"]', this.formElement).each(function (index, element) {
            var $fieldWrap = $(element).closest('.acf-field');
            var $fileinput = $fieldWrap.find(inputSelector);
            var mimeTypes = _this.defaultValue($(element).data('mime_types'), '').split(',').filter(String).concat(_this.defaultValue($fieldWrap.data('mime_types'), '').split(',').filter(String));
            // Add dots before extensions & add mime types to input
            $fileinput.attr('accept', mimeTypes.map(function (ext) { return '.' + ext; }).join(','));
        });
    };
    AdvancedForm.prototype.setupFieldRules = function () {
        var _this = this;
        var $ = jQuery;
        var taxDataAttr = 'tax-rules';
        var triggerFieldName = this.getTriggerFieldName();
        if (triggerFieldName === '') {
            return;
        }
        this.$triggerField = $('.acf-field[data-name="' + triggerFieldName + '"]', this.formElement);
        this.fields = $('.acf-field[data-' + taxDataAttr + ']', this.formElement).get();
        this.fieldRules = this.fields.reduce(function (rules, field) {
            var ruleValues = $(field).data(taxDataAttr).split(',');
            ruleValues.forEach(function (ruleValue) {
                if (typeof rules[ruleValue] === 'undefined') {
                    rules[ruleValue] = [];
                }
                rules[ruleValue].push(field);
            });
            return rules;
        }, {});
        this.$triggerField.on('change', function (e) { return _this.toggleFields(); });
        // Hide non-matching fields immediately
        this.toggleFields();
    };
    AdvancedForm.prototype.toggleFields = function () {
        var $ = jQuery;
        $(this.fields).hide();
        $(this.getVisibleFields()).show();
    };
    AdvancedForm.prototype.getVisibleFields = function () {
        var _this = this;
        var rules = Object.keys(this.fieldRules);
        var compare = this.$triggerField.find(':input').val();
        return rules.reduce(function (visibleFields, rule) {
            var _a = rule.match(/^(!?)([^:]+):(.+)$/), inverse = _a[1], tax = _a[2], value = _a[3];
            if ((compare === value && inverse === '') || (compare !== value && inverse === '!')) {
                visibleFields = visibleFields.concat(_this.fieldRules[rule]);
            }
            return visibleFields;
        }, []);
    };
    AdvancedForm.prototype.getTriggerFieldName = function () {
        var $ = jQuery;
        var form_name = $('[data-form]', this.formElement).data('form');
        switch (form_name) {
            case 'form_submit_job':
                return 'job_type';
            case 'form_submit_event':
                return 'event_category';
            default:
                return '';
        }
    };
    return AdvancedForm;
}());
//# sourceMappingURL=AdvancedForms.js.map